<template>
	<div class="template_box" @click.stop="CancelReplyFun()">
		<div class="palace_box">
			<div class="header">
				<div class="title">
					{{ $t('MessagesArr.Replies_title')}} ( {{ replyList.length }} )
				</div>
				<div class="el-icon-close" @click.stop="CancelReplyFun()"></div>
			</div>
			
			<div class="menus_box">
				<div class="menus" v-for="(menu, index) in menus" :key="menu.key" :class="{ active: activeMenu === menu.key }" @click.stop="setActiveMenu(menu)">{{ menu.name }}</div>
			</div>
			<div class="comment_list_box" v-if="replyList.length > 0">
				<div class="comment_list">
					<div class="comment_item" v-for="(item, index) in replyList" :key="index" @click.stop="comment_item(item)">
						<div class="comment_item_header">
							<div class="left_box">
								<div class="avatar" :class="if_routeName_home()  ? 'avatar_default' : 'avatar_pointer'" @click.stop="check_information(item)">
									<img v-if="item && item.avatar && item.avatar != ''" :src="item.avatar" :alt="'TOZO Community ' + item.nickname + ' User Avatar'"/>
									<i v-else class="el-icon-s-custom"></i>
								</div>
								<div class="comment_user_box">
									<div class="comment_user_name">{{ item.nickname }}</div>
									<div class="release_time">{{ $fun.formatTime(item.public_time) }}</div>
								</div>
							</div>
							<div class="right_box">
								<div class="thumb_num">{{ item.thumb }}</div>
								<div class="icon_box_img" @click.stop="give(item)">
									<img v-if="item.is_thumb == 1" src="../../assets/icon/comment_give.png" alt="TOZO thumb img">
									<img v-else src="../../assets/icon/comment_no_give.png" alt="TOZO thumb img">
								</div>
							</div>
						</div>
						
						<h3 class="comment_content" v-html="$fun.textWithLineBreaks(item.content)"></h3>
						<div class="comment_reply" @click.stop="View_replies(item)" v-if="item.reply">
							{{ $t('MessagesArr.View')}} {{ item.reply }} {{ $t('MessagesArr.replies')}}
							<i class="el-icon-arrow-right"></i>
						</div>
					</div>
				</div>
			</div>
			
			<NoData v-else calling_modules="comment-replies-list"></NoData>
		</div>
	</div>
</template>

<script>

import { 
	post_community_postcomments, //帖子评论列表
	post_community_replycomments, //回复评论列表
	post_community_addcomment, //发布评论
	post_community_replycomment, //回复评论
	post_community_commentthumb, //点赞评论
	post_community_delcomment, //删除评论
	
	} from '@/api/community.js'
export default {
	name: 'comment-replies-list',

	props: {
		// Loading: {
		// 	type: Boolean,
		// 	default: false,
		// },
		view_comment_id: {
			default: ""
		},
	}, 
	data() {
		return {
			menus: [
			  { key: "Heat", name: this.$t('CommentList.Heat'), type: 2 },
			  { key: "Time", name: this.$t('CommentList.Time'), type: 1  },
			],
			activeMenu: "Heat", // 默认选中菜单
			Loading: false,
			routeName: "",
			replyList:[],
			post_search: {
				comment_id: this.view_comment_id,
				sort_type: 2, //1： 按时间 2：按点赞量热度， 默认 ：2
			},
			post_page: {
				page: 1, 
				per_page: 10
			},
			reply_page: {
				page: 1, 
				per_page: 10
			},
			delpostItem: "",
			titlePrompt: ""
		}
	},
	
// 监听
	watch: {
		// "searchText": {
		// 	handler: function (newValue, oldValue) {
		// 		if(this.searchText && this.searchText != ''){
		// 			this.icon_search = false
		// 		}else{
		// 			this.icon_search = true
		// 		}
		// 	},
		// 	deep: true
		// },
	},
	
	// beforeCreate() {
		
	// }
	
	created () {
		
	},
  
	mounted() {
		this.set_type_list()
		this.get_routeName()
		// this.post_community_replycomments()
   },
	
	methods: {
		comment_item(item){
			console.log(item)
		},
		
		// 关闭
		CancelReplyFun(){
			console.log('CancelReplyFun')
			this.$emit('CancelReplyFun')
		},
		
		// 判断是否是首页，首页才显示列表的关注按钮
		get_routeName(){
			this.routeName = this.$route.name;
			console.log(this.routeName)
		},
		
		if_routeName_home(){
			return this.routeName == 'users' || this.routeName == 'user-profile'
		},
		
		//查看 粉丝或关注人信息
		// check_information(item){
		// 	console.log(item)
		// 	// 除了首页的帖子,个人列表页面和其他用户页面的列表不能进入个人列表页面
		// 	if(this.if_routeName_home()){ return }
		// 	this.$router.push({
		// 		name: "users",
		// 		params: {
		// 			user_id: item.user_id,
		// 			nickname: item.nickname,
		// 		}
		// 	})
		// },
		
		//查看 粉丝或关注人信息
		check_information(item){
			console.log(item)
			// 除了首页的帖子,个人列表页面和其他用户页面的列表不能进入个人列表页面
			if(this.if_routeName_home()){ return }
			
			let routeParams = {
				name: this.$store.state.userinfo.user_id == item.user_id ? "user-profile" : "users",
			   params: {
			      user_id: item.user_id,
			      nickname: item.nickname,
			   }
			};
			if (this.$route.name === 'home') {
				routeParams.params.previous = "posts-list";
			}else if (this.$route.name === 'users') {
				routeParams.name = "user-post-details"
				let path = this.$router.currentRoute.path
				let previous = path ? path.split("/")[1] : ''
				routeParams.params.previous = previous;
				
				let user = path ? path.split("/")[2] : ''
				if(user){
					routeParams.params.user = user;
				}
			}else{
				let path = this.$router.currentRoute.path
				let previous = path ? path.split("/")[1] : ''
				routeParams.params.previous = previous;
			}
			this.$router.push(routeParams);
		},
		
		View_replies(){
			
		},
		
		//点赞(帖子)
		give(item, status){
			let obj = {
				comment_id: item.comment_id, 
				status: item.is_thumb == 0 ? 1 : 2, //is_thumb: 是否点赞, 0否, 1是, 1是,  //status：1点赞, 2取消
			}
			console.log(obj)
			post_community_commentthumb(obj)
		   .then((res) => {
				console.log(res)
				if(res.code == 0){
					this.set_type_list()
				}else{
					this.exception_handling(res, "commentthumb")
				}
		   })
		   .catch((err) => {
				console.log(err)
				this.exception_handling(err, "commentthumb")
		   })
		},
		
		// 类型切换
		setActiveMenu(menu) {
			if(this.activeMenu == menu.key){ return }
			this.activeMenu = menu.key; // 更新激活的菜单
			this.post_search.sort_type = menu.type; // 更新激活的菜单
			this.set_type_list()
		},
		
		// 根据类型获取数据
		set_type_list(){
			if(this.post_search.sort_type == 1){
				this.get_page_Data_postcomments(this.post_page)
			}else{
				this.get_page_Data_postcomments(this.post_page)
			}
		},
		
		
		// 获取分页 postcomments
		get_page_Data_postcomments(obj) {
			console.log(obj)
			if(obj && obj.page){
				this.post_page.page = obj.page
			}
			if(obj && obj.per_page){
				this.post_page.per_page = obj.per_page
			}
			this.post_community_replycomments(this.post_page)
		},
		
		//获取帖子评论列表
		post_community_replycomments(pageObj){
			if(this.Loading){ return }
			this.Loading = true
			let obj = {
				comment_id: this.post_search.comment_id, 
				sort_type: this.post_search.sort_type, 
				page: pageObj.page,
				per_page: pageObj.per_page
			}
			post_community_replycomments(obj)
		   .then((res) => {
				console.log(res)
				if(res.code == 0){
					this.replyList = res.data.data
					this.Loading = false
				}else{
					this.exception_handling(res, "postreport")
				}
		   })
		   .catch((err) => {
				console.log(err)
				this.exception_handling(err, "postreport")
		   })
		},
		
		//异常处理
		exception_handling(err){
			this.Loading = false
			this.$errorMessage(err)
			// this.$message('err.data.message', 'error')
		},
		
		// 点击提交验证
		// submitForm() {
		// 	this.$refs.ruleForm.validate((valid) => {
		// 		if (valid) {
		// 			this.$message('Submit successfully', 'success')
		// 			// 这里可以添加实际的提交逻辑，比如调用 API
		// 		} else {
		// 			this.$message('Please check your input', 'error')
		// 		}
		// 	});
		// },
		
		//子组件关注操作
		operations(type){
			if(type == 'success'){
				// 操作成功刷新列表数据
				this.set_type_list()
			}
		},
	}
};
</script>

<style lang="less" scoped>
	*{
		box-sizing: border-box;
		font-family: Poppins, Poppins;
	}
	.template_box{
		position: fixed;
		top: 0;
		left: 0;
		background-color: rgba(0, 0, 0, 0.2);
		width: 100%;
		height: 100%;
		padding: 10px;
		z-index: 9999;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.palace_box{
		width: 100%;
		padding: 10px;
		border-radius: 8px;
		background-color: #ffffff;
	}
	.header{
		display: flex;
		padding: 0px 0px;
		position: relative;
		.title{
			color: #06f;
			// color: #2094FA;
			width: 100%;
			height: 24px;
			font-weight: 500;
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 16px;
		}
		.el-icon-close{
			color: #999999;
			font-size: 24px;
			position: absolute;
			top: 0;
			right: 0;
		}
	}

	.menus_box{
		margin-top: 20px;
		padding: 15px 0px;
		display: flex;
		justify-content: flex-end;
		.menus{
			padding: 2px 8px;
			line-height: 1;
			cursor: pointer;
			border-right: 1px solid #999999;
			color: #999999;
			&:last-child{
				border-right: 0px solid #999999;
			}
		}
		.active{
			color: #06f;
			// color: #2094FA;
		}
	}
	.comment_list_box{
		overflow: auto;
	}
	.comment_item{
		padding: 15px 0px;
		cursor: pointer;
		border-bottom: 1px solid #f5f5f5;
		&:last-child{
			border-bottom: 0px solid #f5f5f5;
		}
	}
	.comment_item_header{
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.left_box{
		display: flex;
		align-items: center;
		width: calc(100% - 60px);
		.avatar_pointer{
			cursor: pointer;
		}
		.avatar_default{
			cursor: default;
		}
		.avatar{
			width: 40px;
			height: 40px;
			display: flex;
			justify-content: center;
			align-items: center;
			color: #666666;
			// color: #505050;
			border-radius: 50%;
			overflow: hidden;
			img{
				width: 100%;
				height: 100%;
			}
			.el-icon-s-custom{
				height: 40px;
				display: flex;
				justify-content: center;
				align-items: center;
				width: 100%;
				height: 100%;
				display: flex;
				justify-content: center;
				align-items: center;
				border: 1px #f5f5f5 solid;
				border-radius: 50%;
				font-size: 20px;
				color: #999;
			}
		}
		.comment_user_box{
			width: calc(100% - 55px);
			margin-left: 15px;
		}
		.comment_user_name{
			width: 100%;
			cursor: text;
			display: flex;
			flex-wrap: wrap;
			font-size: 14px;
		}
		.release_time{
			margin-top: 3px;
			font-size: 10px;
			color: #666666;
			// color: #999999;
		}
	}
	.right_box{
		display: flex;
		align-items: center;
		justify-content: flex-end;
		width: 50px;
		margin-left: 10px;
	}
	.thumb_num{
		font-size: 12px;
		color: #06f;
		// color: #2094FA;
		cursor: default;
		margin-right: 5px;
	}
	.icon_box_img{
		cursor: pointer;
		width: 30px;
		height: 30px;
		img{
			width: 100%;
		}
	}
	
	.comment_content{
		margin-top: 15px;
		width: 100%;
		cursor: text;
		line-height: 1.5;
		font-weight: 500;
		/* display: flex; */
		/* flex-wrap: wrap; */
		font-size: 12px;
	}
	.comment_reply{
		font-size: 12px;
		margin-top: 10px;
		cursor: pointer;
		color: #06f;
		// color: #2094FA;
		.el-icon-arrow-right{
			color: #06f;
			// color: #2094FA;
		}
	}
	@media screen and (min-width: 1024px) {
		.palace_box{
			max-width: 800px;
			max-height: 80vh;
			min-height: 50vh;
		}
		.comment_list_box{
			max-height: calc(80vh - 94px);
		}
	}
	@media screen and (max-width: 1024px) {
		.palace_box{
			max-height: calc(100% - 20px);
			min-height: calc(100% - 20px);
			padding: 10px;
			border-radius: 8px;
			background-color: #ffffff;
		}
		.comment_list_box{
			max-height: calc(100vh - 124px);
		}
	}
</style>
